const LoginHeader = () => {
  return (
    <header className="l-header">
      <div className="p-header-con">
        <div className="p-header-logo">
          <h1 className="p-header-logo__img">
            <img
              src="/common/assets/images/logo01.svg"
              alt="渋谷ハチコウ大学"
            />
          </h1>
        </div>
        <div className="p-pc-header__utility">
          <div className="p-pc-header__utility-top">
            <div className="p-pc-header__bg-color">
              <p className="p-pc-header__bg-color-txt">背景色変換</p>
              <div className="p-pc-header__bg-color-item">
                <button className="c-color__btn--normal c-color__btn">
                  白
                </button>
                <button className="c-color__btn--blue c-color__btn">青</button>
                <button className="c-color__btn--black c-color__btn">黒</button>
              </div>
            </div>
            <div className="p-pc-header__font-size">
              <p className="p-pc-header__font-size-txt">文字サイズ</p>
              <div className="p-pc-header__font-size-item">
                <button className="c-font-size__btn--medium c-font-size__btn is-active">
                  標準
                </button>
                <button className="c-font-size__btn--large c-font-size__btn">
                  拡大
                </button>
              </div>
            </div>
          </div>
          <div className="p-pc-header__utility-bottom">
            <a
              className="p-pc-header__btn"
              href={process.env.REACT_APP_SHIBUKATSU_WEB_DOMAIN + "/"}
            >
              シブカツトップページに戻る
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
export default LoginHeader;
